export default {
  components: {
    Pagination: {
      colorText: "white"
    }
  }
};
